import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import "bootstrap/dist/css/bootstrap.css";
import axios from "axios";
import VueAxios from "vue-axios";


import VueSession from "vue-session";
Vue.use(VueSession);

import VueNoty from "vuejs-noty";
import "vuejs-noty/dist/vuejs-noty.css";


Vue.use(VueAxios, axios);

Vue.use(VueNoty);

//axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || "http://45.149.79.110:8080/api/";
 axios.defaults.baseURL =
    process.env.baseURL || process.env.apiUrl || "https://copypeyk.com/api/";
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || "/api/";

Vue.config.productionTip = false;

new Vue({
    i18n,
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");